import { UploadedFile } from "./uploaded-file.model";

export interface PlasticsDockInspectionInstance {
	id: string;
	createdOn: Date;
	createdById: string;
	productVersionId: string;
	skidId: string;
	qualityAlertId: string;
	updatedOn: Date;
	updatedById: string;
	status: PlasticsDockInspectionInstanceStatus;
	inspectionInstanceHistory: PlasticsDockInspectionInstanceHistoryItem[];
}

export interface PlasticsDockInspectionInstanceHistoryItem {
	id: string;
	createdOn: Date;
	status: PlasticsDockInspectionInstanceStatus;
	createdById: string;
	files: UploadedFile[];
}

export enum PlasticsDockInspectionInstanceStatus {
	PASSED = 'PASSED',
	FAILED = 'FAILED',
	NOT_STARTED = 'NOT STARTED'
}